export default function initCookie() {
  const isPresent = document.querySelector(".cookie-notification");
  if (!isPresent) {
    return;
  }

  const domainName = window.location.hostname;

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
  }

  const button = document.querySelector(".cookie-btn");
  const notification = document.querySelector(".cookie-notification");

  button.addEventListener("click", function () {
    setCookie("cookie_agreement", "yes", 30);

    notification.classList.remove("cookie-notification-visible");
  });

  if (getCookie("cookie_agreement") !== "yes") {
    notification.classList.add("cookie-notification-visible");
  }
}
